import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

const ImageZoomer = ({ imageUrl, style }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        textAlign: 'center',
        position: 'relative',
        width: 'fit-content',
        height: 'fit-content',
      }}
    >
      <IconButton
        color="info"
        size="small"
        onClick={() => setOpen(true)}
        sx={{ position: 'absolute', right: -4, top: -4 }}
      >
        <ZoomInIcon />
      </IconButton>
      {/* Clickable Image */}
      <img
        src={imageUrl}
        alt="Zoomable"
        style={style ?  {...style, cursor: 'pointer'} :{ width: '100%', cursor: 'pointer', borderRadius: '10px' }}
        onClick={() => setOpen(true)}
      />

      {/* Pop-up for Zoomed Image */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogContent>
          <img
            src={imageUrl}
            alt="Zoomed"
            style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ImageZoomer;
